
import { defineComponent, reactive, onMounted, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import { useHead } from '@vueuse/head'
import { RepositoryFactory } from '@/repositories/RepositoryFactory'
const PlayerRepository = RepositoryFactory.get('player')

import BaseBreadcrumb, { Breadcrumb } from '@/components/BaseBreadcrumb.vue'


import { Player } from '@/types/player'

export default defineComponent({
  name: 'PlayerDetail',
  inheritAttrs: false,
  components: {
    BaseBreadcrumb,
  },
  setup() {
    const route = useRoute()
    const store = useStore()

    onMounted(() => {
      getPlayer()
    })

    const player: {
      data?: Player
    } = reactive({
      data: undefined
    })

    const getPlayer = async () => {
      try {
        const { player_id } = route.params

        const res = await PlayerRepository.getPlayer(player_id)

        if (res.status === 200) {
          const r = res.data
          const data = r.data

          player.data = data.player
        }
      } catch (error) {
        //
      }
    }

    const playerForm = reactive({
      isCompleted: false
    })

    watch(
      () => [player.data?.name],
      () => {
        playerForm.isCompleted = (player.data?.name !== '') ? true : false
      },
      { immediate: true }
    )

    const updatePlayer = async () => {
      try {
        const dataObj = {
          player_id: player.data?.id,
          name: player.data?.name
        }

        const res = await PlayerRepository.updatePlayer(dataObj)

        if (res.status === 200) {
          store.dispatch('addFlashMessage', {
            type: 'success',
            message: '選手名を変更しました'
          })
        }
      } catch (error) {
        //
      }
    }

    useHead({
      title: computed(() => player.data?.name + ' - 選手詳細'),
    })

    const breadcrumbs = computed(() => {
      return [
        {
          type: 'link',
          link: {
            name: '選手一覧',
            path: '/player'
          }
        },
        {
          type: 'text',
          text: {
            name: player.data?.name
          }
        }
      ] as Breadcrumb[]
    })

    return {
      player,
      getPlayer,

      playerForm,
      updatePlayer,

      breadcrumbs
    }
  }
})
